import {useQueries} from "@tanstack/react-query";
import locationService from "../../../../../../services/web/location-service.js";
import citizenService from "../../../../../../services/web/citizen-service.js";
import roleService from "../../../../../../services/web/role-service.js";
import placeService from "../../../../../../services/web/place-service.js";
import corporationService from "../../../../../../services/web/corporation-service.js";
import citizenProgramService from "../../../../../../services/web/protection-program-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['locationTypes'],
                queryFn: () => locationService.getLocationType().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['educations'],
                queryFn: () => citizenService.getEducations().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['races'],
                queryFn: () => citizenService.getRaces().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['religions'],
                queryFn: () => citizenService.getReligions().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['familyConnections'],
                queryFn: () => citizenService.getFamilyConnections().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['places'],
                queryFn: () => placeService.allPlaces().then(data => data.map(({id, text}) => ({value: id, label: text})))
            },
            {
                queryKey: ['headers'],
                queryFn: () => corporationService.headerTemplates()
            },
            {
                queryKey: ['programs'],
                queryFn: () => citizenProgramService.options()
            }
        ]
    });

    return {
        locationTypes: queries[0].data ?? [],
        educations: queries[1].data ?? [],
        races: queries[2].data ?? [],
        religions: queries[3].data ?? [],
        familyConnections: queries[4].data ?? [],
        places: queries[5].data ?? [],
        headers: queries[6].data ?? [],
        programs: queries[7].data ?? []
    }
};

export default UseFetchData;